<template>
	<div id="signup" v-if="loaded">
		<div class="form-group">
			<div class="form-line" v-on:click="addressPickerShow = true">
				<label>联系人</label>
				<input type="text" v-model="realname" placeholder="请填写"/>
			</div>
			<div class="form-line">
				<label>手机号码</label>
				<input type="text" v-model="phone" placeholder="请填写"/>
			</div>
			<div class="form-line" v-on:click="kemuPicker = true">
				<label>驾照类型</label>
				<input type="text" :value="kemu | pickerValueFilter" placeholder="请选择"/>
			</div>
			<div class="form-line">
				<label>我的位置</label>
				<input type="text" v-model="address" placeholder="请填写"/>
			</div>
			<div class="form-line">
				<label>留言</label>
				<textarea v-model="content" placeholder="如有其它要求，请填写"></textarea>
			</div>
		</div>
		<div class="btn" v-on:click="event_submit">
			提交
		</div>
		<wv-picker
		  :visible.sync="kemuPicker"
		  :columns="kemuColumns"
		  v-model="kemu"
		  value-key="name"
		  @confirm="kemuConfirm"
		/>
	</div>
</template>

<script>

export default {
  data () {
    return {
		loaded:false,
		kemu:['C1'],
		phone:'',
		realname:'',
		content:'',
		address:'',
		kemuPicker:false,
		submited:false,
		kemuColumns:[
		  {
			values: ['C1','C2','B1','B2','B3','A1','A2','A3']
		  }
		]
	}
  },
  mounted () {
  },
  created(){
	this.loaded = true
  },
  methods: {
	  	kemuConfirm(v,t){
			console.log(v);
		},
		event_submit(){
			var that = this
			if(this.submited){
				this.$wx.showToast('请等待教练联系您');
				return false;
			}
			this.$app.pr('/Api/Signup/add',{
				realname:this.realname,
				mobile:this.phone,
				content:this.content,
				kemu:this.kemu.join(' '),
				address:this.address,
				user_id:this.$route.query.bg_user_id
			}).then((res) => {
				if(res.success){
					this.$wx.showToast('请等待教练联系您');
					this.submited = true
					setTimeout(function(){
						that.$router.push('/')
					},2000)
				}else{
					this.$wx.showToast(res.message);
				}
			});
		}
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#signup{
		background-color:#f4fcff;
		min-height:100vh;
	}
	.form-group{
	}
	.form-group .form-line{
		width:100%;
		display:flex;
		display:-webkit-flex;
		background-color:#FFFFFF;
		padding:0px 3vw;
		margin:1.5vw 0vw;
	}
	.form-group .form-line label{
		display:inline-block;
		width:20vw;
		font-size:3.6vw;
		color:#898989;
		line-height:12vw;
	}
	.form-group .form-line input{
		height:12vw;
		border:0px;
		color:#5d5d5d;
		text-align:right;
	}
	.form-group .form-line textarea{
		height:20vw;
		border:0px;
		color:#5d5d5d;
		text-align:right;
		padding:5px 0px;
		line-height:7vw;
	}
	.form-group .form-line input,.form-group .form-line textarea{
		flex:1;
		-webkit-flex:1;
	}
	.btn{
		height:12vw;
		display:block;
		margin:5vw 3vw;
		text-align:center;
		color:#FFFFFF;
		background:linear-gradient(to right, #fa8d60, #e76025);
		font-size:4vw;
		line-height:12vw;
		border-radius:10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Signup.vue